export const NIGERIAN_UNIVERSITIES: string[] = [
  // Federal Universities
  "Ahmadu Bello University, Zaria",
  "University of Ibadan",
  "University of Lagos",
  "Obafemi Awolowo University, Ile-Ife",
  "University of Benin",
  "University of Nigeria, Nsukka",
  "University of Ilorin",
  "University of Port Harcourt",
  "University of Calabar",
  "Bayero University, Kano",
  "Usmanu Danfodiyo University, Sokoto",
  "Nnamdi Azikiwe University, Awka",
  "University of Abuja",
  "Federal University of Technology, Akure",
  "Federal University of Technology, Owerri",
  "Federal University of Technology, Minna",
  "Modibbo Adama University, Yola",
  "Michael Okpara University of Agriculture, Umudike",
  "Federal University of Agriculture, Abeokuta",
  "Abubakar Tafawa Balewa University, Bauchi",
  "National Open University of Nigeria",
  "Nigerian Defence Academy, Kaduna",
  "Alex Ekwueme Federal University, Ndufu-Alike",
  "Federal University, Lafia",
  "Federal University, Dutsin-Ma",
  "Federal University, Kashere",
  "Federal University, Wukari",
  "Federal University, Otuoke",
  "Federal University, Lokoja",
  "Federal University, Birnin Kebbi",
  "Federal University, Gusau",
  "Federal University, Gashua",
  "Federal University, Oye-Ekiti",
  "Air Force Institute of Technology, Kaduna",
  "Nigerian Maritime University, Okerenkoko",

  // State Universities
  "Lagos State University",
  "Rivers State University",
  "Olabisi Onabanjo University",
  "Adekunle Ajasin University, Akungba",
  "Ladoke Akintola University of Technology",
  "Ekiti State University",
  "Bamidele Olumilua University of Education, Science and Technology, Ikere-Ekiti (BOUESTI)",
  "Osun State University",
  "Abia State University",
  "Imo State University",
  "Enugu State University of Science and Technology",
  "Delta State University",
  "Ambrose Alli University, Ekpoma",
  "Benue State University",
  "Nasarawa State University, Keffi",
  "Kaduna State University",
  "Aliko Dangote University of Science and Technology, Wudil",
  "Yusuf Maitama Sule University, Kano",
  "Plateau State University, Bokkos",
  "Taraba State University",
  "Bauchi State University, Gadau",
  "Gombe State University",
  "Adamawa State University, Mubi",
  "Kwara State University",
  "Prince Abubakar Audu University, Anyigba",
  "Niger Delta University",
  "Ebonyi State University",
  "University of Cross River State (UNICROSS)",
  "Chukwuemeka Odumegwu Ojukwu University",
  "Olusegun Agagu University of Science and Technology",
  "Sule Lamido University, Kafin Hausa",
  "Sokoto State University",
  "Kebbi State University of Science and Technology, Aliero",
  "Ignatius Ajuru University of Education",
  "Tai Solarin University of Education",
  "Delta State University of Science and Technology, Ozoro",
  "University of Medical Sciences, Ondo",
  "Edo State University, Uzairue",
  "Borno State University",
  "Zamfara State University, Talata Mafara",
  "Bayelsa Medical University",

  // Private Universities
  "Covenant University",
  "Babcock University",
  "Bowen University",
  "Igbinedion University, Okada",
  "Afe Babalola University, Ado-Ekiti",
  "Redeemer's University",
  "Bells University of Technology",
  "Caleb University",
  "Ajayi Crowther University",
  "Al-Hikmah University",
  "Landmark University",
  "Madonna University",
  "Joseph Ayo Babalola University",
  "Caritas University",
  "Renaissance University",
  "Benson Idahosa University",
  "Novena University",
  "Obong University",
  "Rhema University",
  "Salem University",
  "Tansian University",
  "Paul University, Awka",
  "Achievers University",
  "Adeleke University",
  "Mountain Top University",
  "Pan-Atlantic University",
  "Lead City University",
  "Crawford University",
  "Fountain University",
  "Baze University",
  "American University of Nigeria, Yola",
  "Nile University of Nigeria",
  "Veritas University",
  "University of Mkar",
  "Wesley University",
  "Summit University, Offa",
  "Skyline University Nigeria",
  "Greenfield University",
  "Claretian University of Nigeria",
  "Dominican University",
  "Eko University of Medicine and Health Sciences",
  "PAMO University of Medical Sciences",
  "Hallmark University",
  "Precious Cornerstone University",
  "Coal City University",
  "Spiritan University, Nneochi",
  "Hezekiah University",
  "Gregory University, Uturu",
  "Kings University",
  "Oduduwa University",
  "Southwestern University",
  "Chrisland University",
  "Christopher University",
  "Augustine University",
  "McPherson University",
  "KolaDaisi University",
  "Dominion University",
  "Samuel Adegboyega University",
  "Michael and Cecilia Ibru University",
  "Trinity University",
  "Thomas Adewumi University",
  "Topfaith University",
  "Admiralty University of Nigeria",
  "Ave Maria University",
  "Al-Qalam University, Katsina",
  "Maryam Abacha American University of Nigeria",
  "Khadija University, Majia",
  "Kwararafa University, Wukari",
  "Mudiame University",
  "Bingham University",
  "ECWA Bingham University",
  "Eastern Palm University (now KO Mbadiwe University)",
  "Yaba College of Technology (Degree programmes)",
  // The list includes federal, state, and private universities recognized by NUC.
];